export default __webpack_public_path__ + "static/media/pasta.3bb7411a.jpg";